<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search bpm-approval-process">
        <div class="section">
          <el-form
            label-position="left"
            label-width="120px"
          >
            <div class="el-form-item-wrapper" style="display: flex">
              <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
                <el-input v-model="form.tenantName" style="width: 150px;padding-left: 10px" clearable />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_IdentifyTheSupplier')" style="padding-left: 10px">
                <el-select v-model="form.channel" style="width: 150px;" clearable>
                  <el-option v-for="(item,index) in CONSIGNMENT_NOTE_PLATFORMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
              </el-form-item>
              <div style="padding-left: 10px">
                <el-button type="primary" @click="queryHandler">
                  {{ $t('CargoMsg.Cargo_Query') }}
                </el-button>
                <el-button type="primary" @click="addHandler">
                  {{ $t('CargoMsg.Cargo_Add') }}
                </el-button>
                <el-button type="primary" @click="editHandler">
                  {{ $t('CargoMsg.Cargo_Edit') }}
                </el-button>
                <el-button type="danger" @click="deleteHandler">
                  {{ $t('CargoMsg.Cargo_OrderDelete') }}
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          style="width: 100%;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 新增编辑弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="settingDialog.visible"
      :title="$t('CargoMsg.AE_IDENTIFY_VENDORS')"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="130px" label-position="left">
          <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
            <cargo-advance-select
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              callback-method-type="obj"
              style="width: 200px"
              :default-value="String(settingDialog.form.tenant)||''"
              @parentCallBack="changeTenant"
            />
          </el-form-item>
          <div style="display: flex;padding-bottom: 5px">
            <el-button type="primary" @click="editWindowHandler">
              {{ $t('CargoMsg.Cargo_NewTo') }}
            </el-button>
            <el-button type="danger" @click="deleteWindowHandler">
              {{ $t('CargoMsg.Cargo_OrderDelete') }}
            </el-button>
          </div>
          <cargo-ag-grid
            :column-defs="editWindowColumnDefs"
            :row-data="editWindow.rowData"
            :grid-options="editWindow.gridOptions"
            style="width: 750px"
            @gridReady="params=>editWindow.gridApi=params.api"
          />
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="settingDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import {
  BILL_PLATFORMS,
  CONSIGNMENT_NOTE_PLATFORMS,
  CUSTOMS_PLATFORMS,
  IDENTIFY_TYPE_0,
  IDENTIFY_TYPE_1,
  IDENTIFY_TYPE_2, IDENTIFY_TYPE_3, IDENTIFY_TYPE_4, IDENTIFY_TYPE_5, IDENTIFY_TYPE_6, IDENTIFY_TYPE_7,
  IDENTIFY_TYPE_LIST,
  SENDING_BY,
  SENDING_CWMI,
  SENDING_MNH,
  SENDING_XHQ2
} from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { deleteOcrConfigFunc, getOcrList, saveOcrConfigFunc } from '@/api/ocrCancelConfig'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getName, getStateByCode, getStateIndexByCode } from '@/class/cargo/model/parameters/CommonState'
import { getOcrTemplateList } from '@/api/ocrTemplate'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import lodash from 'lodash'

export default {
  name: 'OcrRecognitionSetting',
  components: {
    CargoAdvanceSelect
  },
  data() {
    return {
      TYPE_NAMES,
      isZh: this.$store.getters.language === 'zh',
      CONSIGNMENT_NOTE_PLATFORMS,
      BILL_PLATFORMS,
      CUSTOMS_PLATFORMS,
      selectTypeNames: TYPE_NAMES,
      ColumnUtils,
      loading: false,
      currentExpress: null,
      selectedRow: null,
      windowSelectedRow: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      form: {
        tenantName: '',
        channel: ''
      },
      settingDialog: {
        title: this.$t('CargoMsg.Cargo_Add'),
        visible: false,
        form: {
          uuid: '',
          version: 0,
          tenant: 0
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: 'TenantId',
          field: 'tenant',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.TENANT_BUSINESS_NAME'),
          field: 'tenantName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_IdentifyTheSupplier'),
          field: 'channelRemark',
          width: 600
        }
      ],
      gridApi: null,
      editWindow: {
        rowData: [],
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          // 单击显示编辑
          singleClickEdit: true,
          suppressCellSelection: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => { this.windowSelectedRow = event.data }
        }
      },
      tsTemplateList: [], // ts ocr模板列表
      customsTemplateList: [], // customs ocr模板列表
      allTemplateList: [], // 所有的ocr模板列表
      SENDING_CWMI
    }
  },
  computed: {
    editWindowColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_IdentificationType'),
          colId: 'type',
          field: 'type',
          initialWidth: 100,
          valueFormatter: (params) => {
            const state = getStateByCode(IDENTIFY_TYPE_LIST, params.value)
            return getName(state)
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: params => {
            return {
              selectProps: {
                filterable: true,
                clearable: true,
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions: IDENTIFY_TYPE_LIST
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IdentifyTheSupplier'),
          colId: 'channel',
          field: 'channel',
          initialWidth: 200,
          width: 300,
          valueFormatter: (params) => {
            const state = getStateByCode(CONSIGNMENT_NOTE_PLATFORMS, params.value)
            return getName(state)
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: params => {
            const array = this.getType(params.data.type)
            return {
              selectProps: {
                filterable: true,
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions: array
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TemplateSettings'),
          colId: 'ocrTemplateUuid',
          field: 'ocrTemplateUuid',
          initialWidth: 200,
          width: 300,
          valueFormatter: (params) => {
            const state = getStateIndexByCode(this.allTemplateList, params.value, 'uuid')
            if (state) {
              return state.templateName
            }
          },
          editable: (params) => params.data.channel === SENDING_CWMI.code,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: params => {
            let array = []
            if (params.data.channel === SENDING_CWMI.code) {
              array = this.allTemplateList
            }
            return {
              selectProps: {
                filterable: true,
                tagValue: 'uuid',
                tagName: 'templateName',
                filterTagNames: ['templateName'],
                staticOptions: array
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }]
    }
  },
  created() {
    this.queryHandler()
    getOcrTemplateList().then(res => {
      this.allTemplateList = res.data || []
    })
  },
  methods: {
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedRow = node.data
          }
        })
      }
    },
    queryHandler() {
      this.loading = getLoading4Cxt()
      const data = {
        anyStr1: this.form.tenantName,
        anyStr2: this.form.channel
      }
      getOcrList(data).then(res => {
        if (res.data) {
          const CHANNEL_TYPES = [
            { key: 'tsChannel', type: IDENTIFY_TYPE_0 },
            { key: 'tdChannel', type: IDENTIFY_TYPE_1 },
            { key: 'customsChannel', type: IDENTIFY_TYPE_2 },
            { key: 'aeTsChannel', type: IDENTIFY_TYPE_3 },
            { key: 'airTdChannel', type: IDENTIFY_TYPE_4 },
            { key: 'amsEnsChannel', type: IDENTIFY_TYPE_5 },
            { key: 'bcPartChannel', type: IDENTIFY_TYPE_6 },
            { key: 'boxListChannel', type: IDENTIFY_TYPE_7 }
          ]

          for (const data of res.data) {
            const r = CHANNEL_TYPES.map(channelType => {
              const channelValue = data[channelType.key]
              if (channelValue) {
                return getName(channelType.type) + '：' + getName(getStateByCode(CONSIGNMENT_NOTE_PLATFORMS, channelValue))
              }
              return null
            }).filter(Boolean)

            data.channelRemark = r.join('；')
          }
          this.rowData = res.data
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.settingDialog.form = {
        uuid: '',
        version: 0,
        tenant: 0
      }
      this.editWindow.rowData = []
      this.settingDialog.visible = true
    },
    editHandler() {
      if (!this.selectedRow || this.selectedRow.length === 0) {
        this.$message.warning(this.$t('CargoMsg.FormEditTip'))
        return
      }
      this.settingDialog.form = { ...this.selectedRow }
      this.editWindow.rowData = lodash.cloneDeep(this.settingDialog.form.detailList)
      this.settingDialog.visible = true
    },
    getType(type) {
      let array = []
      if (type === IDENTIFY_TYPE_0.code) {
        array = [SENDING_MNH, SENDING_BY, SENDING_XHQ2, SENDING_CWMI]
      } else if (type === IDENTIFY_TYPE_1.code) {
        array = [SENDING_BY, SENDING_CWMI]
      } else if ([IDENTIFY_TYPE_2.code, IDENTIFY_TYPE_3.code, IDENTIFY_TYPE_4.code, IDENTIFY_TYPE_5.code, IDENTIFY_TYPE_6.code, IDENTIFY_TYPE_7.code].includes(type)) {
        array = [SENDING_CWMI]
      }
      return array
    },
    deleteHandler() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.FormDeleteTip'))
        return
      }
      this.$confirm(this.$t('CargoMsg.DTip'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt()
        const data = {
          keys: Array.from(selectedRows, p => p.uuid)
        }
        deleteOcrConfigFunc(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.queryHandler()
          this.selectedRow = null
          this.gridApi.clearFocusedCell() // 清除选中行
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    saveHandler() {
      if (!this.editWindow.rowData || this.editWindow.rowData.length === 0) {
        // 请设置识别类型对应的供应商
        this.$message.warning(this.$t('CargoMsg.Cargo_IdentificationTip1'))
        return
      }
      const form = { ...this.settingDialog.form }
      form.detailList = this.editWindow.rowData
      if (!form.tenant) {
        // 请输入租户企业名称
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.TENANT_BUSINESS_NAME'))
        return
      }
      const channelObj = {}
      for (const data of this.editWindow.rowData) {
        if (!data.type) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSet') + this.$t('CargoMsg.Cargo_IdentificationType'))
          return
        }
        if (!data.channel) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSet') + this.$t('CargoMsg.Cargo_IdentifyTheSupplier'))
          return
        }
        if (data.channel === SENDING_CWMI.code && !data.ocrTemplateUuid) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Template.TemplateName'))
          return
        }
        const i = channelObj[data.type]
        if (i === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyOneSupplier'))
          return
        } else {
          channelObj[data.type] = 1
        }
      }
      this.loading = getLoading4Cxt()
      form.tenant = Number(this.settingDialog.form.tenant)
      saveOcrConfigFunc(form).then(res => {
        if (res.data) {
          this.selectedRow = this.settingDialog.form
          this.queryHandler()
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.settingDialog.visible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    onCellChange(p) {
      if (p.data.channel !== SENDING_CWMI.code) { p.data.ocrTemplateUuid = '' }
      this.editWindow.gridApi.refreshCells({ force: true })
    },
    editWindowHandler() {
      const newConfiguration = {
        type: '0',
        channel: '',
        ocrTemplateUuid: ''
      }
      this.editWindow.rowData.push(newConfiguration)
    },
    deleteWindowHandler() {
      if (!this.windowSelectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const index = this.editWindow.rowData.findIndex(p => p === this.windowSelectedRow)
      if (index > -1) {
        this.editWindow.rowData.splice(index, 1)
      }
    },
    changeTenant(p) {
      this.settingDialog.form.tenant = p.value
      this.settingDialog.form.tenantName = p.name
    }
  }
}
</script>
